import script from "./technicians.vue?vue&type=script&setup=true&lang=js"
export * from "./technicians.vue?vue&type=script&setup=true&lang=js"

import "./technicians.vue?vue&type=style&index=0&id=e4cfaab2&lang=css"

const __exports__ = script;

export default __exports__